export const questionnaireKeys = {
  all: ['questionnaires'] as const,
  lists: () => [...questionnaireKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...questionnaireKeys.lists(), filters] as const,
  detail: (id: string) => [...questionnaireKeys.all, 'detail', id] as const,
};
